import React, { useContext, useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import VehicleList from '../components/lists/VehicleList';
import { AuthContext } from '../contexts/authContext';
import {
  useDefaultVehicles,
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierVehicleTypesPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const { defaultVehicles } = useDefaultVehicles();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierVehicles = useMemo(
    () => [...defaultVehicles, ...(selectedCarrier?.vehicles || [])],
    [defaultVehicles, selectedCarrier?.vehicles]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'classPermission');

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {canView && (
        <>
          <StickyPageHeader
            subtitle={selectedCarrier.name}
            title="Vehicle Types"
          />
          <VehicleList
            carrier={selectedCarrier}
            id="vehicle-types"
            vehicles={carrierVehicles}
          />
        </>
      )}
    </Layout>
  );
};

export default CarrierVehicleTypesPage;
